import { idyuGetDataContainer } from "@/assets/js/idyu/reference.js";
import Vue from "vue";

const md5 = require("md5-nodejs");

export function idyuCryptPassword(lg, pd) {
  return md5("$1$/G10LWKG" + lg.toUpperCase() + "*" + pd);
}

async function idyuPrivateRpcCall(data, tryno = 1) {
  const res = await fetch("/api" + "/MY-JSON-RPC", {
    method: "POST",
    credentials: "include",
    body: data,
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json; charset=UTF-8"
    }
  });

  if (res.ok === false) {
    throw "Erreur (1): Impossible de se connecter à Idylive.";
  }

  const resultObj = await res.json();
  if (resultObj.error && resultObj.error !== 0) {
    if (resultObj.error === 1 && tryno === 1) {
      if ((await idyuReconnect()) == 0) {
        try {
          return idyuPrivateRpcCall(data, 2);
        } catch {
          //
        }
      }
    }

    throw "Erreur (2): Impossible de se connecter à Idylive.";
  } else {
    return resultObj.result;
  }
}

export async function idyuConnect(lg, crypt) {
  try {
    const res = await idyuJsonRpc("doLogin", lg, crypt, "FRA");
    if (res === 0) {
      localStorage.login = lg;
      localStorage.password = crypt;
    }
    return res;
  } catch {
    return 1;
  }
}

export async function idyuReconnect() {
  let password = localStorage.password;
  let login = localStorage.login;

  if (!password) {
    password = Vue.$cookies.get("crypt");
  }

  if (!login) {
    login = Vue.$cookies.get("login");
  }

  if (login && password) {
    return await idyuConnect(login, password);
  }
  return 1;
}

export async function idyuJsonRpc() {
  const obj = {};

  obj.method = arguments[0];
  obj.id = "123";
  obj.jsonrpc = "2.0";
  obj.params = [];

  let i = 1;
  while (i < arguments.length) {
    obj.params.push(arguments[i]);
    i++;
  }

  const data = JSON.stringify(obj);

  return await idyuPrivateRpcCall(data, 1);
}

export async function idyuRetrieveSession() {
  try {
    const res = await idyuJsonRpc("newRetrieveSession");
    if (!res) return null;
    res.data = await idyuGetDataContainer();
    return res;
  } catch (_err) {
    return null;
  }
}

export async function idyuLoadProfile(id) {
  const profile = await idyuJsonRpc("getProfileFromId", id);

  return profile;
}
